var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('restaurant-reviews-widget-section',{staticClass:"restaurant-reviews-widget-section",attrs:{"title":_vm.attributes.restaurantReviewsWidgetSection_title,"token":_vm.attributes.token,"widget-id":_vm.attributes.widget_id}})}
var staticRenderFns = []

export { render, staticRenderFns }